import React from 'react';
import './_styles.scss';

const BrandHeading = ({ value }) =>
  value && <h1 className="mnd-brand-heading">{value}</h1>;

export default BrandHeading;
